import script from "./suspend-right.vue?vue&type=script&setup=true&lang=js"
export * from "./suspend-right.vue?vue&type=script&setup=true&lang=js"

import "./suspend-right.vue?vue&type=style&index=0&id=5b075cd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b075cd6"]])

export default __exports__